/**
 * Labels for bank / credit card approval requests (create, update, delete).
 */
export function getBankAccountApprovalTitle(
  actionCode: string | undefined,
  rawJson: { account_type?: unknown } | null | undefined,
): string {
  const code = (actionCode || "create").toLowerCase();
  const at = rawJson?.account_type;
  const isCredit = at === "credit" || at === "credit_card";
  if (code === "delete") {
    return isCredit ? "Delete Credit Card Account" : "Delete Bank Account";
  }
  if (code === "update") {
    return isCredit ? "Update Credit Card Account" : "Update Bank Account";
  }
  return isCredit ? "Create Credit Card Account" : "Create Bank Account";
}
